import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./Header.css";
import { bindActionCreators } from "redux";
import { SaveData } from "../Actions/HomeAction";
import { connect } from "react-redux";

function Search(props) {
  const [search, setSearch] = useState("");
  const [validated, setValidated] = useState(true);
  const navigate = useNavigate();
  const searchStorageValue = props?.data;

  const searchValue = (e) => {
    setSearch(e.target.value);
    search ? props?.SaveData("") : props?.SaveData(e.target.value)

  };

  function handleSubmit(event) {
    props?.SaveData(search || searchStorageValue); 
    event.preventDefault();
    if (search || searchStorageValue) {
        setValidated(true);
        navigate("/searchdetails");
    } else {
      setValidated(false);
    }
  }

  return (
    <div className="search flex-fill">
      <Form className="searchForm d-flex" onSubmit={handleSubmit}>
        <Form.Group className="flex-fill" controlId="formBasicSearch">
          <Form.Control
            className="searchField"
            name="search"
            onChange={searchValue}
            type="search"
            value={!search ? searchStorageValue : search}
            placeholder="Ex: https://indiankanoon.org/doc/498126"
          />
        </Form.Group>
        {!validated && (
          <div className="error">
            Please enter Letters or Ex: https://indiankanoon.org/doc/498126
          </div>
        )}
        <Button className="searchButton" type="submit">
          Summarise
        </Button>
      </Form>
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({ SaveData }, dispatch),
  };
}

const mapStateToProps = (state) => ({
  data: state.homeReducer.data,
});
export default connect(mapStateToProps, mapDispatchToProps)(Search);
